
import {
  AbstractControl, FormArray, FormControl, FormGroup,
} from '@angular/forms';

export type FormGroupControls = { [key: string]: AbstractControl };
export type AbstractControlValue<T> = T extends { value: infer Y } ? Y : never;

export class EnhancedFormControl<T = unknown> extends FormControl {
  declare readonly value: T;
}

export class EnhancedFormArray<T extends AbstractControl> extends FormArray {
  declare controls: T[];

  declare readonly value: AbstractControlValue<T>[];

  static create<K extends AbstractControl>(controls: K[]): EnhancedFormArray<K> {
    return new EnhancedFormArray<K>(controls);
  }
}

export class EnhancedFormGroup<T extends FormGroupControls> extends FormGroup {
  declare controls: T;

  declare readonly value: { [key in keyof T]: AbstractControlValue<T[key]> };

  static create<K extends FormGroupControls>(controls: K): EnhancedFormGroup<K> {
    return new EnhancedFormGroup<K>(controls);
  }

  override getRawValue(): { [key in keyof T]: AbstractControlValue<T[key]> } {
    return super.getRawValue();
  }
}
